const ACTION_TYPES = {
  CREATE_ASSESSMENT: "CREATE_ASSESSMENT",
  FETCH_ASSESSMENTS: "FETCH_ASSESSMENTS",
  READ_ASSESSMENT: "READ_ASSESSMENT",
  FILTER_ASSESSMENT: "FILTER_ASSESSMENT",
  READ_QUESTIONS: "READ_QUESTIONS",
  CLEAR_ASSESSMENTRESPONSE: "CLEAR_ASSESSMENTRESPONSE",
  ASSESSMENT_SUBMIT: "ASSESSMENT_SUBMIT",
  ASSESSMENT_RESULT: "ASSESSMENT_RESULT",
  IS_WEB_VIEW: "IS_WEB_VIEW",
  IS_KTV_ASSESSMENT_VIEW: "IS_KTV_ASSESSMENT_VIEW",

  CREATE_QUESTION: "CREATE_QUESTION",
  ADD_TEMP_QUESTION: "ADD_TEMP_QUESTION",
  FETCH_QUESTIONS: "FETCH_QUESTIONS",
  READ_QUESTION: "READ_QUESTION",
  REMOVE_QUESTION: "REMOVE_QUESTION",
  UPDATE_CORRECT_OPTION: "UPDATE_CORRECT_OPTION",
  UPLOAD_IMAGE_QUESTION: "UPLOAD_IMAGE_QUESTION",
  UPDATE_QUESTION: "UPDATE_QUESTION",
  GET_QUESTION: "GET_QUESTION",
  CLEAR_QUESTION: "CLEAR_QUESTION",
  CLEAR_QUESTION_WITH_INDEX: "CLEAR_QUESTION_WITH_INDEX",
  GET_SELECTED_QUESTION: "GET_SELECTED_QUESTION",
  GET_PREVIOUS_QUESTION: "GET_PREVIOUS_QUESTION",

  CREATE_OPTION: "CREATE_OPTION",
  FETCH_OPTIONS: "FETCH_OPTIONS",
  UPLOAD_IMAGE_OPTION: "UPLOAD_IMAGE_OPTION",
  UPDATE_OPTION: "UPDATE_OPTION",
  REMOVE_OPTION: "REMOVE_OPTION",
  SELECTED_OPTION: "SELECTED_OPTION",
  CLEARSELECTED_OPTION: "CLEARSELECTED_OPTION",

  GOT_ERROR: "GOT_ERROR",
  CLEAR_ERROR: "CLEAR_ERROR",

  SHOW_LOADER: "SHOW_LOADER",
  HIDE_LOADER: "HIDE_LOADER",

  GET_ASSESSMENTRESPONSE: "GET_ASSESSMENTRESPONCE",
  GET_QUESTIONRESPONSE: "GET_QUESTIONRESPONCE",
  CREATE_ASSESSMENTRESPONSE: "CREATE_ASSESSMENTRESPONCE",
  FETCH_ALLASSESSMENTRESPONSES: "FETCH_ALLASSESSMENTRESPONSES",
  LOADING_QUESTIONRESPONSE: "LOADING_QUESTIONRESPONSE",

  FETCH_IQ_QUESTIONS: "FETCH_IQ_QUESTIONS",
  FETCH_HAPPINESS_QUESTIONS: "FETCH_HAPPINESS_QUESTIONS",
  FETCH_CONDUCT_QUESTIONS: "FETCH_CONDUCT_QUESTIONS",
  FETCH_ATTENTION_QUESTIONS: "FETCH_ATTENTION_QUESTIONS",
  FETCH_PERSONALITY_QUESTIONS: "FETCH_PERSONALITY_QUESTIONS",
  FETCH_TEXTUAL_MEMORY_QUESTIONS: "FETCH_TEXTUAL_MEMORY_QUESTIONS",
  SUBMIT_TEXTUAL_MEMORY_QUESTIONS: "SUBMIT_TEXTUAL_MEMORY_QUESTIONS",
  FETCH_VISUAL_MEMORY_QUESTIONS: "FETCH_VISUAL_MEMORY_QUESTIONS",
  SUBMIT_VISUAL_MEMORY_QUESTIONS: "SUBMIT_VISUAL_MEMORY_QUESTIONS",
  CHANGE_VISUAL_MEMORY_IMAGE: "CHANGE_VISUAL_MEMORY_IMAGE",
  CHANGE_VISUAL_MEMORY_IMAGE_RESET: "CHANGE_VISUAL_MEMORY_IMAGE_RESET",
  ADD_RESPONSES: "ADD_RESPONSES",
  ADD_HAPPINESS_RESPONSES: "ADD_HAPPINESS_RESPONSES",
  ADD_CONDUCT_RESPONSES: "ADD_CONDUCT_RESPONSES",
  ADD_ATTENTION_RESPONSES: "ADD_ATTENTION_RESPONSES",
  ADD_PERSONALITY_RESPONSES: "ADD_PERSONALITY_RESPONSES",
  GET_IQRESULT: "GET_IQRESULT",
  GET_USER_PROFILE: "GET_USER_PROFILE",
  UPLOAD_ANSWER_FILES: "UPLOAD_ANSWER_FILES",
  REMOVE_ANSWER_FILES: "REMOVE_ANSWER_FILES",

  //Notification
  GETALL_NOTIFICATION: "GETALL_NOTIFICATION",
  DELETEALL_NOTIFICATION: "DELETEALL_NOTIFICATION",

  // Digital Me Actions
  FETCH_STUDENT_PROFILE: "FETCH_STUDENT_PROFILE",
  UPDATE_STUDENT_PROFILE: "UPDATE_STUDENT_PROFILE",
  FETCH_VALID_VALUES: "FETCH_VALID_VALUES",

  //CLASS FEED
  GETALL_POSTS: "GETALL_POSTS",
  CREATE_POST: "CREATE_POST",
  UPDATE_POST: "UPDATE_POST",
  DELETE_POST: "DELETE_POST",
  CREATE_COMMENT: "CREATE_COMMENT",
  UPDATE_COMMENT: "UPDATE_COMMENT",
  DELETE_COMMENT: "DELETE_COMMENT",
  CLEARALL_POSTS: "CLEARALL_POSTS",
  GET_ALL_STUDENTS_OF_CLASS: "GET_ALL_STUDENTS_OF_CLASS",
  NOTIFICATION_UPDATE: "NOTIFICATION_UPDATE",
  ADD_POST_BYNOTIFICATION: "ADD_POST_BYNOTIFICATION",

  // ROLLBACK
  SET_SHOW_ASSESSMENT_ROLLBACK: "SET_SHOW_ASSESSMENT_ROLLBACK",


  //UI
  SHOW_WEB_VIEW: "SHOW_WEB_VIEW",
  HIDE_WEB_VIEW: "HIDE_WEB_VIEW",
  SHOW_SIDE_BAR: "SHOW_SIDE_BAR",
  HIDE_SIDE_BAR: "HIDE_SIDE_BAR",

  UPDATE_KNOWLEDGE_REPORT: "UPDATE_KNOWLEDGE_REPORT"
};

export default ACTION_TYPES;
